// -- events --
export const kEventConfirm = "cohere:confirm"

// -- classes --
export const kClassHidden = "is-hidden"
export const kClassVisible = "is-visible"
export const kClassEmpty = "is-empty"
export const kClassActive = "is-active"
export const kClassDisabled = "is-disabled"
export const kClassSelected = "is-selected"
export const kClassLoaded = "is-loaded"
